import actionTypes from 'src/modules/redux/actionTypes'

export const setLoading = isLoading => ({
  type: actionTypes.SET_SIDEBAR_USERS_LOADING,
  payload: isLoading
})
